module.exports = __webpack_public_path__ + "assets/img/LTC038.b436b2fd.png";